import { BrandHomeQuery } from '@water-web/api';

export const BrandHomeConstructor = (apiUrl: string) => ({
  byId: new BrandHomeQuery(apiUrl),
});
